import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    input: {
        width: '230px',
    },
    select: {
        width: '328px',
    },
}));

/**
 *
 * Side Menu HOOKS
 *
 * @param props
 * @returns {html}
 * @constructor
 */
export function SideMenu (props){
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [input, setInput] = React.useState('');
    const inputLabel = React.useRef(null);
    const classes = useStyles();

    /**
     * Update urn calling the props callback from streams list
     * set the selected item with the index param
     *
     * @param event
     * @param index Number, array position
     * @param data Object, stream object
     */
    function handleStreamsClick(event, index, data) {
        //TODO handle selected urn stream button on init with url params
        setSelectedIndex(index);
        props.callbackURN(data.src);
    }

    /**
     * Update urn calling the callback using input
     */
    function handleURNClick() {
        props.callbackURN(input);
        setSelectedIndex(100);
    }

    /**
     * get the mediacomposition using the callback
     */
    function handleMediaCompositionClick() {
        props.callbackMediaCompo();
    }

    /**
     * get the mediacomposition using the callback
     */
    function handlePlayerDocumentation() {
        props.callbackPlayerDocumentation();
    }

    /**
     * update the environment host using the callback
     *
     * @param event
     */
    function handleRadioButtonEnvChange(event) {
        props.callbackEnv(event.target.value);
    }

    const handleBranchDropBoxChange = event => {
        props.callbackPlayer(event.target.value);
    };

    function handleRadioButtonLangChange(event) {
        props.callbacklang(event.target.value);
    }

    /**
     * Render, streams list, urn input, mediacompostion getter,
     * environment radiobutton selection
     */
    return (
        <div>
        <List component="nav" className={classes.root} subheader={<ListSubheader>{props.datas.streams.title}</ListSubheader>}>
            {props.datas.streams.buttons.map((data, index) =>
                    <ListItem alignItems="flex-start"
                              button
                              key={index}
                              selected={selectedIndex === index}
                              onClick={event => handleStreamsClick(event, index, data)}>
                        <ListItemText
                            primary={data.title}
                            secondary={''}
                        />
                    </ListItem>
            )}
        </List>
            <Divider />
        <List component="nav" className={classes.root} subheader={<ListSubheader>{props.datas.tools.title}</ListSubheader>}>
            <ListItem alignItems="flex-start">
                <Input
                    placeholder="urn:rsi:video:1511530"
                    className={classes.input}
                    value={input}
                    onInput={e => setInput(e.target.value)}
                    inputProps={{
                        'aria-label': 'Description',
                    }}
                />
                <ListItemSecondaryAction>
                    <Button variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={event => handleURNClick(event)}>
                        Add
                    </Button>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem alignItems="flex-start">
                <ListItemText primary="MediaComposition" />
                <ListItemSecondaryAction>
                    <Button variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={event => handleMediaCompositionClick(event)}>
                        Go
                    </Button>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem alignItems="flex-start">
                <FormControl className={classes.formControl}>
                    <InputLabel ref={inputLabel} id="player">Branches</InputLabel>
                    <Select
                        id="player"
                        size="small"
                        className={classes.select}
                        value={props.initPlayer}
                        onChange={handleBranchDropBoxChange}
                    >
                        <MenuItem value={'player'}>Prod (master branch)</MenuItem>
                        <MenuItem value={'stage'}>Develop (develop branch)</MenuItem>
                        <MenuItem value={'local'}>Local (http://localhost:1234)</MenuItem>
                        <MenuItem value={'test'}>Test (test/test branch)</MenuItem>
                        <MenuItem value={'test_rinaldo'}>Test Rinaldo (test/rinaldo branch)</MenuItem>
                        <MenuItem value={'test_andre'}>Test André (test/andre branch)</MenuItem>
                        <MenuItem value={'test_seb'}>Test Seb (test/seb branch)</MenuItem>
                    </Select>
                </FormControl>
            </ListItem>
            <ListItem alignItems="flex-start">
                <ListItemText primary="Documentation" />
                <ListItemSecondaryAction>
                    <Button variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={event => handlePlayerDocumentation(event)}>
                        Go
                    </Button>
                </ListItemSecondaryAction>
            </ListItem>
            <Divider />
        </List>
            <List component="nav" className={classes.root} subheader={<ListSubheader>{props.datas.tools.environments.title}</ListSubheader>}>
            <ListItem alignItems="flex-start">
                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        aria-label="environment"
                        name="environment"
                        className={classes.group}
                        value={props.initEnv}
                        onChange={handleRadioButtonEnvChange}
                        row
                    >
                {props.datas.tools.environments.radioButtons.map((data, index) =>
                    <FormControlLabel
                        key={index}
                        value= {data.host}
                        control={<Radio color="primary" />}
                        label= {data.title}
                        labelPlacement="start"
                    />
                )}
                </RadioGroup>
                </FormControl>
            </ListItem>
        </List>
            <List component="nav" className={classes.root} subheader={<ListSubheader>{props.datas.tools.lang.title}</ListSubheader>}>
                <ListItem alignItems="flex-start">
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            aria-label="language"
                            name="language"
                            className={classes.group}
                            value={props.initLang}
                            onChange={handleRadioButtonLangChange}
                            row
                        >
                            {props.datas.tools.lang.radioButtons.map((data, index) =>
                                <FormControlLabel
                                    key={index}
                                    value= {data.code}
                                    control={<Radio color="primary" />}
                                    label= {data.title}
                                    labelPlacement="start"
                                />
                            )}
                        </RadioGroup>
                    </FormControl>
                </ListItem>
            </List>
        </div>
    );

}

